// extracted by mini-css-extract-plugin
export default {"navLink":"TabItem_navLink__XpCZb"};